<template>
    <v-card light class="main">
        <v-card-title>Ссылка на Youtube видео</v-card-title>
        <v-card-text>
            <v-text-field label="URL" v-model="url"></v-text-field>
        </v-card-text>
        <v-card-actions>
            <div class="flex-md-grow-1"></div>
            <v-btn
                    color="#8a2be2"
                    text
                    @click="closer"
            >
                Отмена
            </v-btn>
            <v-btn
                    color="#8a2be2"
                    text
                    @click="submit"
            >
                Сохранить
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    export default {
        props:['closer'],
        name: "videoInput",
        data(){
            return{
                valueLocal: this.value,
                url:""
            }
        },
        methods:{
            submit(){
                this.$emit('url', this.url)
                this.closer()
            }
        }
    }
</script>

<style scoped>
    .main{
        width: 500px;
    }
</style>